const taxEuArray = [
  "AT", "BE", "BG", "CZ", "DK", "EE", "FI", "FR", "DE",
  "HU", "IE", "IT", "NL", "PL", "PT", "RO", "ES", "SE"
];

const taxNonEuArray = ["AL", "AD", "NO", "CH", "UA"];

const vatMappings = [
  { rate: 1.23, mainVat: 'Inc Vat', subVat: 'Ex Vat', countries: taxEuArray },
  { rate: 0, mainVat: 'Ex Vat', subVat: '', countries:taxNonEuArray }
]

const mapping = vatMappings.find(c => c.countries.includes(userCountry));

export const vatRate = mapping ? mapping.rate : 0;
export const mainVat = mapping ? mapping.mainVat : '';
export const subVat = mapping ? mapping.subVat : '';